import { customerName } from './helpers';

const CustomerName = ({ customer, boldName }) => {
  if (boldName) {
    return <strong>{customerName(customer)}</strong>;
  }
  return <>{customerName(customer)}</>;
};

export default CustomerName;
